import { Component, OnInit } from '@angular/core';
import { StatsService } from 'src/app/core/services/stats.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ValidadoresService } from '../../../../core/services/validadores.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';

@Component({
  selector: 'app-docs-updated-by-day',
  templateUrl: './docs-updated-by-day.component.html',
  styleUrls: ['./docs-updated-by-day.component.scss']
})
export class DocsUpdatedByDayComponent implements OnInit {

  loading: boolean;
  mostrarListado: boolean;
  mostrarError: boolean;
  datosDocumentosTime = [];
  datosGrafica = [];
  fechaAdestacar = { name: "", value: 0 };
  filtro: FormGroup;
  totalDocumentosSubidos: number = 0;

  constructor(
    private statsService: StatsService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private validadores: ValidadoresService,
  ) {

    this.loading = false;
    this.mostrarListado = false;
    this.mostrarError = false;
    this.datosDocumentosTime = [];


  }

  ngOnInit() {
    this.filtro = this.fb.group({
      fechaInicial: ['', [this.validadores.fechaNoAdecuada]],
      fechaFinal: ['', [this.validadores.fechaNoAdecuada]]
    });
  }

  VisualizarDatos(fechaInicial: string, fechaFinal: string) {

    let inicial: number = this.GetFechaInteger(fechaInicial);
    let final: number = this.GetFechaInteger(fechaFinal);

    this.loading = true;
    this.mostrarError = false;
    this.mostrarListado = false;
    this.datosDocumentosTime = [];
    this.datosGrafica = [];
    this.totalDocumentosSubidos = 0;

    this.statsService.ObtenerDocumentosSubidosPorDias(inicial, final).subscribe(datos => {

      this.loading = false;
      this.datosDocumentosTime = datos;


      this.datosGrafica = datos.map(item => {
        const fecha: any = {};

        fecha.name = item.item1.toString();
        fecha.value = item.item2;

        this.totalDocumentosSubidos = this.totalDocumentosSubidos + item.item2;

        return fecha;
      });

      this.mostrarListado = true;

    }, (error) => {

      this.loading = false;
      this.mostrarError = true;
    });
  }

  FormatearEjeX(a: string): string {

    function NombreMes(mes: string, caracteres: number = 0, upper: boolean = false): string {
      const m = Number(mes);

      if (isNaN(m) == true) {
        return "";
      }

      let nombre = "";

      switch (m) {
        case 1: nombre = "enero"
          break;
        case 2: nombre = "febrero"
          break;
        case 3: nombre = "marzo"
          break;
        case 4: nombre = "abril"
          break;
        case 5: nombre = "mayo"
          break;
        case 6: nombre = "junio"
          break;
        case 7: nombre = "julio"
          break;
        case 8: nombre = "agosto"
          break;
        case 9: nombre = "septiembre"
          break;
        case 10: nombre = "octubre"
          break;
        case 11: nombre = "noviembre"
          break;
        case 12: nombre = "diciembre"
          break;
      }

      if (caracteres > 0) {
        nombre = nombre.substr(0, caracteres);
      }

      if (upper == true) {
        nombre = nombre.toUpperCase();
      }

      return nombre;
    }

    if (a.substr(6, 2) == "01" || a.substr(6, 2) == "15") {

      const nombreMes = NombreMes(a.substr(4, 2), 3, true);

      const ano = a.substr(2, 2);
      const dia = a.substr(6, 2);

      return `${dia} ${nombreMes} ${ano}`;
    }

    return "";
  }

  private formatearFechasYvalores() {

    for (var i = 0; i < this.datosDocumentosTime.length; i++) {

      this.datosDocumentosTime[i].name = this.convertDateToString(this.datosDocumentosTime[i].name);

    }
  }

  private GetFechaInteger(date: string): number {
    if (date == "" || date == undefined) {
      return 0;
    }

    if (date.length != 10) {
      return 0;
    }

    let dia = Number(date.substr(0, 2));
    let mes = Number(date.substr(3, 2));
    let ano = Number(date.substr(6, 4));

    if (Number.isNaN(dia) == true || dia == undefined || Number.isNaN(mes) == true || mes == undefined || Number.isNaN(ano) == true || ano == undefined) {
      return 0;
    }

    return ano * 10000 + mes * 100 + dia;
  }

  private convertDateToString(number) {
    if (isNaN(number) === false) {
      if (number > 0) {
        number = number.toString().substring(6, 8) + '/' + number.toString().substring(4, 6) +
          '/' + number.toString().substring(0, 4);
        return number;
      }
    }
    return '';
  }

  fechaChange($event, esFecha: number) {

    let fechaall: string = "";

    if (typeof ($event) === "string") {
      fechaall = $event;
    } else if (typeof ($event) === "number") {
      fechaall = $event.toString();
    } else if ($event.target != undefined && $event.target != null) {
      fechaall = $event.target.value;
    }

    let format = 'dd/mm/yy';

    let resultado = "";
    let fecha = "";

    if (fechaall.length == 10) {
      while (fechaall.indexOf("/") > -1) {
        fechaall = fechaall.replace("/", "");
      }
    }

    let diasMes = fechaall.substring(0, 2);
    let mesFecha = fechaall.substring(2, 4);

    if (fechaall) {
      if (fechaall.length > 8 || fechaall.length < 4 || fechaall.length == 7 || fechaall.length == 5) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(diasMes) > 31 || parseInt(diasMes) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(mesFecha) > 12 || parseInt(mesFecha) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else {

        if (fechaall.indexOf('/') >= 0 && fechaall != "") {

          let fechaArray = fechaall.split('/');

          let dia = fechaArray[0];
          dia = dia.length < 2 ? "0" + (dia) : dia;

          let mes = fechaArray[1];
          mes = mes.length < 2 ? "0" + (mes) : mes;

          let hoy = new Date;

          let anio = fechaArray[2];

          if (anio) {
            switch (anio.length) {
              case 4:
                anio = anio; break;
              case 2:
                anio = "20" + anio; break;
              default:
                anio = '';
            }

          } else { anio = hoy.getFullYear().toString(); }

          if (dia != '' && mes != '' && anio != '') {
            fecha = dia + mes + anio;
          }

        } else {
          fecha = fechaall;
        }

        if (this.isNumber(fecha)) {

          if (format === 'dd/mm') {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + fecha.substring(4, 8);
                break;
              case 6:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

          }
          else {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + fecha.substring(4, 8);
                break;
              case 6:
                var anio = fecha.substring(4, 6);

                if (parseInt(anio.substring(0, 1)) <= 9 && parseInt(anio.substring(0, 1)) >= 5) {
                  anio = "19" + anio;
                } else {
                  anio = "20" + anio;
                }
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

            moment.locale("es");
            var fechaValidacion = moment().format(resultado);

            if (!moment(fechaValidacion, 'DD-MM-YYYY').isValid()) {

              this.toastr.error('Fecha incorrecta.');

              resultado = "";

            } else {

              resultado = fechaValidacion;
            }
          }
        } else {
          this.toastr.error('Fecha incorrecta.');
          resultado = "";
        }

      }
    }

    if (esFecha == 1) {

      this.filtro.patchValue({
        fechaInicial: resultado
      });
    }
    if (esFecha == 2) {

      this.filtro.patchValue({
        fechaFinal: resultado
      });
    }
  }

  private isNumber(numero) {
    if (this.isDecimal(numero) || !isNaN(parseInt(numero))) {
      return true;
    }
    return false;
  }

  private isDecimal(numero) {
    if (typeof numero === 'undefined') {
      return false;
    } else {
      numero = Math.abs(numero);
    }

    var pattern = /^\d+(\.\d*)?$/;
    if (pattern.test(numero)) {
      return true;
    }
    else {
      return false;
    }
  }

  convertThousandsFixed(number: any, digits) {

    if (typeof number === 'undefined') {
      number = 0.0;
    }

    if (this.isDecimal(number) === true) {
      number = parseFloat((Math.round(number * 100) / 100).toString()).toFixed(2);

      number = number.toString().replace('.', ',');
    }

    var value = number.toString().split('.').join('');
    var numbers = value.split(',');
    var enter = numbers[0];
    var new_number = '';

    var amount = enter.toString();
    amount = amount.split('').reverse();
    var output = '';
    for (var i = 0; i <= amount.length - 1; i++) {
      output = amount[i] + output;
      if ((i + 1) % 3 === 0 && (amount.length - 1) !== i) output = '.' + output;
    }

    if (digits !== '0') {

      if (numbers.length === 1) {
        if (numbers[0] === '') {
          new_number = output;
        } else {
          new_number = output + ',00';
        }
      } else {
        if (numbers[1] === '') {
          new_number = output + ',00';
        } else {
          if (numbers[1].substring(0, 2).length === 1) {
            new_number = output + ',' + numbers[1].substring(0, 1) + '0';
          } else {
            new_number = output + ',' + numbers[1].substring(0, digits);
          }
        }
      }
      if (new_number.substring(0, 1) === '-' && new_number.substring(1, 2) === '.') {
        new_number = new_number.replace('.', '');
      }
      if (new_number === '0,0000') {
        new_number = '0,00';
      }
    } else {
      new_number = output;
      if (numbers[1] !== undefined) {
        new_number = new_number + ',' + numbers[1];
      }
    }

    if (digits === '0') {
      numbers = new_number.split(',');
      if (Number(numbers[1]) === 0) {
        new_number = numbers[0];
      }
    }

    return new_number;
  }



}


